import PropTypes from "prop-types";

import ComponentsSelector from "./ComponentsSelector";
import { COMPONENT_SHAPE } from "./constants";
import {
  buildMultiLevelsValue,
  parseMultiLevelsValue,
} from "./hierarchicalComponentsUtils";

const HierarchicalComponents = ({
  value = "",
  onChange = () => {},
  ...rest
}) => {
  // on any level change event, we rebuild the new value (example: "roof.beam")
  const onSubComponentSelected = (newSlugLevel, newSlugValue) =>
    onChange(buildMultiLevelsValue({ value, newSlugLevel, newSlugValue }));

  return (
    <ComponentsSelector
      selectedSlugs={parseMultiLevelsValue(value)}
      level={0}
      onSubComponentSelected={onSubComponentSelected}
      {...rest}
    />
  );
};

HierarchicalComponents.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  components: PropTypes.arrayOf(PropTypes.shape(COMPONENT_SHAPE)).isRequired,
};

export default HierarchicalComponents;
